(() => {
  if (window.ehqEmailProtection) return;
  const marker = /__ehq_email_([A-Za-z0-9+/=]+)__/g;
  const decode = value => value.replace(marker, (_, encoded) => atob(encoded));
  const readable = /[A-Za-z0-9_+.-]+(?: \[dot\] [A-Za-z0-9_+-]+)* \[at\] [A-Za-z0-9-]+(?: \[dot\] [A-Za-z0-9-]+)+/g;
  const emailLink = address => {
    const link = document.createElement('a');
    link.href = 'mailto:' + address;
    link.textContent = address;
    link.style.color = 'inherit';
    link.style.textDecoration = 'inherit';
    link.setAttribute('data-ehq-email-restored', '');
    return link;
  };
  const restore = root => {
    if (root.nodeType !== 1 && root.nodeType !== 9 && root.nodeType !== 11) return;
    const elements = root.nodeType === 1 ? [root, ...root.querySelectorAll('*')] : [...root.querySelectorAll('*')];
    for (const el of elements) {
      if (el.hasAttribute('data-ehq-email')) {
        try {
          el.textContent = atob(el.getAttribute('data-ehq-email'));
          el.removeAttribute('data-ehq-email');
          el.setAttribute('data-ehq-email-restored', '');
          if (!el.closest('a,button')) {
            el.replaceWith(emailLink(el.textContent));
          }
        } catch (_) { /* Leave the readable fallback intact. */ }
      }
      for (const attr of [...el.attributes]) {
        if (!attr.value.includes('__ehq_email_')) continue;
        try {
          let value = attr.value;
          if (attr.name === 'href' && value.startsWith('/pages/contact#__ehq_email_')) {
            value = value.replace('/pages/contact#', 'mailto:');
          }
          el.setAttribute(attr.name, decode(value));
        } catch (_) { /* Retain the contact-page fallback. */ }
      }
    }
    // Shopify's native policy renderer can strip data attributes from spans.
    const walker = document.createTreeWalker(root, NodeFilter.SHOW_TEXT);
    const nodes = [];
    while (walker.nextNode()) {
      const node = walker.currentNode;
      if (node.nodeValue.includes(' [at] ') && !node.parentElement?.closest('script,style,textarea,noscript')) nodes.push(node);
    }
    for (const node of nodes) {
      const fragment = document.createDocumentFragment();
      let start = 0;
      for (const match of node.nodeValue.matchAll(readable)) {
        fragment.append(document.createTextNode(node.nodeValue.slice(start, match.index)));
        const address = match[0].replace(' [at] ', '@').replaceAll(' [dot] ', '.');
        fragment.append(node.parentElement.closest('a,button') ? document.createTextNode(address) : emailLink(address));
        start = match.index + match[0].length;
      }
      if (start) {
        fragment.append(document.createTextNode(node.nodeValue.slice(start)));
        node.replaceWith(fragment);
      }
    }
  };
  window.ehqEmailProtection = {restore};
  restore(document);
  new MutationObserver(records => {
    for (const record of records) for (const node of record.addedNodes) restore(node);
  }).observe(document.documentElement, {childList: true, subtree: true});
})();
